import ConfigUtil from '../util/ConfigUtil';

const FooterContainer = () => {
    return (
        <footer>
            <div className='footer-wrap'>
                <div className='footer-top'>
                    <ul className='footer-link-set'>
                        <li className='footer-link-items'>
                            <a
                                href={ConfigUtil.getExternalLink_PrivacyPolicy()}
                                rel='noopener noreferrer'
                                target='_blank'
                            >
                                개인정보처리방침
                            </a>
                        </li>
                        <li className='footer-link-items'>
                            <a href={ConfigUtil.getExternalLink_Home()} rel='noopener noreferrer' target='_blank'>
                                국민대학교 미래혁신단(미래자동차사업단)
                            </a>
                        </li>
                        <li className='footer-link-items'>
                            <a href={ConfigUtil.getExternalLink_Directions()} rel='noopener noreferrer' target='_blank'>
                                찾아오시는길
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='footer-main'>
                    <div className='footer-name'>
                        <p>첨단분야 혁신융합대학사업(미래자동차)</p>
                        <p>미래혁신단(미래자동차사업단)</p>
                    </div>
                    <div className='footer-info'>
                        <p>서울특별시 성북구 정릉로 77 국민대학교 산학협력관 301호</p>
                        <span>TEL : 02-910-6677</span>
                        <span>FAX : 02-910-6672</span>
                    </div>
                    <div className='footer-copyright'>
                        <p>Copyright 2022. Kookmin University. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterContainer;
